/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSupplementNameRequest
 */
export interface UpdateSupplementNameRequest {
    /**
     * New display name for the supplement
     * @type {string}
     * @memberof UpdateSupplementNameRequest
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateSupplementNameRequest interface.
 */
export function instanceOfUpdateSupplementNameRequest(value: object): value is UpdateSupplementNameRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateSupplementNameRequestFromJSON(json: any): UpdateSupplementNameRequest {
    return UpdateSupplementNameRequestFromJSONTyped(json, false);
}

export function UpdateSupplementNameRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplementNameRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpdateSupplementNameRequestToJSON(json: any): UpdateSupplementNameRequest {
    return UpdateSupplementNameRequestToJSONTyped(json, false);
}

export function UpdateSupplementNameRequestToJSONTyped(value?: UpdateSupplementNameRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

